var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.isMobileLayout ? 'transition' : _setup.BCXQuickLayer,{tag:"component",attrs:{"name":"bcx-transition-fade-scale","auto-position":"","is-open":_vm.isOpen,"x-pos":-400,"y-pos":-12,"width":370,"adapt-bounding-on-size-change":"","adapt-bounding-after-move":""}},[(_vm.isOpen)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }